// JQuery
import $ from 'jquery';

// Swiper
import Swiper from 'swiper/bundle';

// Javascript
import { initBasics } from './basics.js';
import { initVimeoVideo } from './vimeo.js';
import { initSwipers } from './swipers.js';
import { initFAQ } from './faq.js';

$(document).ready(function() {

    function initPage(){

        initBasics();
        initVimeoVideo();
        initSwipers();
        initFAQ();

    }

    initPage();

});